import React from "react";
import { AptitudeSection } from "../AptitudeSection";
import { useSelector } from "react-redux";
import {
  getFeedbackForm,
  getInterviewResult,
  getProfileForm,
} from "../../../../redux/reducer/incbotFeedbackReducer";
import { interviewPayloadHasWritten } from "../writtenQuestionUtils";
import { CodingSection } from "../CodingSection";
import { QUESTION_TYPES } from "../../../../constants";
import { GeneralQuestionsSection } from "../GeneralQuestionsSection";
import SpecificQuestionSection from "../SpecificQuestionSection";
import WrittenSection from "../WrittingSection";
import PsychometricScreeningSection from "./PsychometricScreeningSection";

const ScreeningQuestionsView: React.FC = () => {
  const feedbackForm = useSelector(getFeedbackForm);
  const interview = useSelector(getInterviewResult);
  const profileForm = useSelector(getProfileForm);
  const isPsychometricAssessment = profileForm?.interviewType === "psychometric_assessment";

  const banner = (
    <div className="md:hidden print:flex w-100 p-1 print:p-2 rounded-md border-b-4 border-teal-500 bg-teal-50 text-teal-500 text-md print:text-xl flex justify-center font-semibold mb-3 md:mb-6">
      Screening Questions
    </div>
  );

  if (isPsychometricAssessment) {
    return (
      <div className="p-3 md:p-6">
        {banner}
        <PsychometricScreeningSection />
      </div>
    );
  }

  return (
    <div className="p-3 md:p-6">
      {banner}
      {(feedbackForm?.questions?.data || [])?.filter(
        (question: any) => question.questionType === QUESTION_TYPES.GLOBAL
      )?.length > 0 && <GeneralQuestionsSection />}
      {(feedbackForm?.questions?.data || [])?.filter(
        (question: any) =>
          question.questionType === QUESTION_TYPES.CUSTOM ||
          question.questionType === QUESTION_TYPES.AI_GENERATED
      )?.length > 0 && <SpecificQuestionSection />}
      {(feedbackForm?.questions?.data || [])?.filter(
        (question: any) => question.questionType === QUESTION_TYPES.CODING
      )?.length > 0 && <CodingSection />}
      {feedbackForm?.aptitudeSectionData?.sectionsData?.length > 0 && <AptitudeSection />}
      {(interviewPayloadHasWritten(interview) ||
        (feedbackForm?.questions?.data || []).some((question: any) => {
          const qt = String(question?.questionType || "").toLowerCase();
          return qt === QUESTION_TYPES.WRITING;
        })) && <WrittenSection />}
    </div>
  );
};

export default ScreeningQuestionsView;
